import CASL from '@/utils/constants/casl'

export default {
  path: 'survey-material',
  children: [
    {
      path: '',
      name: 'survey-material.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.SURVEY_MATERIAL
      },
      component: () => import('./list/SurveyMaterialListPage.vue')
    },
    {
      path: ':uid',
      name: 'survey-material.detail',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.SURVEY_MATERIAL
      },
      component: () => import('./form/SurveyMaterialFormPage.vue')
    }
  ]
}
